export default __webpack_public_path__ + "static/media/jCAD.832ff304.png";